<div class="row">
  <div class="col-md-12 comment-frame">
    <div class="facbook-title">תגובות</div>
    <div class="col-md-12">
      <div class="rate-btn-wrapper">
        <div class="rate-btn">
          <div
            class="send-comment-btn"
            (click)="displayCommentFormChange(true)"
          >
            תן ציון ושלח תגובה
          </div>
          <div class="star-wrapper">
            <span
              *ngFor="let star of starsArray; let index = index"
              (click)="setStar(index)"
            >
              <span class="empty-star" *ngIf="index >= stars">
                <fa-icon [icon]="['far', 'star']"></fa-icon>
              </span>
              <span class="full-star" *ngIf="index < stars">
                <fa-icon [icon]="['fas', 'star']"></fa-icon>
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="comment-list">
        <ol>
          <li *ngFor="let userComment of prodComments; let index = index">
            <div class="comment-name">
              {{ userComment.Name }}
            </div>
            <div class="star-wrapper-list">
              <span *ngFor="let star of starsArray; let index = index">
                <span class="full-star" *ngIf="index < userComment.Stars">
                  <fa-icon [icon]="['fas', 'star']"></fa-icon>
                </span>
              </span>
            </div>
            <div class="comment-msg">
              {{ userComment.CommentMsg }}
            </div>
          </li>
        </ol>
      </div>
    </div>
    
  <div id="comments" class="facbook-title">תגובות בפייסבוק</div>
  <div id="fb-root"></div>
  <div
    class="fb-comments"
    [attr.data-href]="currentUrl"
    data-numposts="5"
    data-mobile="true"
  ></div>
  </div>
</div>


